import axios from "axios";
import { config } from "./constants";

export const axiosApiInstance = axios.create({
  baseURL: config.url.API_URL,
});

export const axiosStorageInstance = axios.create({
  baseURL: config.url.STORAGE_URL,
});

export const axiosPrinterInstance = axios.create({
  baseURL: config.url.PRINTER_URL,
});

export const axiosEthernetPrinter1Instance = axios.create({
  baseURL: config.url.ETHERNET_PRINTER_1_URL,
});

export const axiosEthernetPrinter2Instance = axios.create({
  baseURL: config.url.ETHERNET_PRINTER_2_URL,
});